import { HTMLAttributes } from 'react';
import Footer from '@/website/components/Footer';
import { Box } from '@mui/material';

type PageLayoutFooterProps = HTMLAttributes<HTMLDivElement>;

const PageLayoutFooter = (props: PageLayoutFooterProps) => {
  return (
    <Box id="jove-website-page-layout-footer">
      <Footer />
    </Box>
  );
};

export default PageLayoutFooter;
